module.exports = __webpack_public_path__ + "static/img/cont54 (3).368abb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont54 (3).jpg
// module id = 7wpl
// module chunks = 0